import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

export const _frontmatter = {};
const layoutProps = {
  _frontmatter
};
const MDXLayout = "wrapper";
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">
    <h2>{`Get in touch`}</h2>
    <p>{`Say Hi on `}<a href="https://www.linkedin.com/in/barasec" target="_blank">{`LinkedIn`}</a>{`, Email `}<a href="mailto:barasec@protonmail.com">{`me`}</a>{`, view my code on `}<a href="https://github.com/barasec" target="_blank">{`GitHub`}</a>{`, or read my `}<a href="https://drive.google.com/file/d/1Rrg298IxXvQKcJKCFzhdwazRcqYdhJ0o/view?usp=sharing" target="_blank">{`CV`}</a>{` 👋`}</p>
    <br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br /><br />

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      